export default __webpack_public_path__ + "images/emitir-cartao-ico.svg";